const Fetcher = require('./fetcher');

const create = (data = {}) => new Fetcher(data);

module.exports = {create};
